import React from 'react';
import omit from 'lodash/omit';
import {
  Dialog,
  FlatButton,
} from 'material-ui';
import {
  translate as t,
} from 'admin-on-rest';


export default function withConfirmDialog(ButtonComponent) {
  class WithConfirmDialog extends React.Component {
    state = {
      open: false,
    }

    confirm = () => {
      const { onClick } = this.props;
      this.close();
      if (onClick) onClick();
    }

    open = () => {
      this.setState({ open: true });
    }

    close = () => {
      this.setState({ open: false });
    }


    render() {
      const {
        translate, confirmationText, confirmationTitle,
        submitText, cancelText,
      } = this.props;
      const filteredProps = omit(this.props, ['onClick', 'translate', 'confirmationText']);
      const actions = [
        <FlatButton
          label={cancelText || translate('cancel')}
          onClick={this.close}
          primary
        />,
        <FlatButton
          label={submitText || translate('submit')}
          onClick={this.confirm}
          primary
        />,
      ];
      return (
        <>
          <ButtonComponent onClick={this.open} {...filteredProps} />
          <Dialog
            title={confirmationTitle}
            actions={actions}
            open={this.state.open}
            modal
          >
            {confirmationText}
          </Dialog>
        </>
      );
    }
  }

  const wrappedComponentName = ButtonComponent.displayName || ButtonComponent.name || 'Component';
  WithConfirmDialog.displayName = `WithConfirmDialog(${wrappedComponentName})`;
  return t(WithConfirmDialog);
}
